export enum ContractStatus {
  Active = "Active",
  OnHold = "OnHold",
  Cancelled = "Cancelled",
}
